import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { client } from '../../utils/client'
import { OrderStatus } from 'src/utils/enum'

// Actions - used with useDispatch
export const bankAccountSlice = createSlice({
  name: 'bankAccount',
  initialState: {
    fundBalance: 0,
    bankAccount: null,
    pendingBankaccount: null,
    getFundBalance: {
      status: null,
      error: null,
    },
    addBankAccount: {
      status: null,
      error: null,
    },
    updateBankAccount: {
      status: null,
      error: null,
    },
    getBankAccount: {
      status: null,
      error: null,
    },
    getPendingBankAccount: {
      status: null,
      error: null,
    },
    delistBankAccount: {
      status: null,
      error: null,
    },
    withdrawFund: {
      status: null,
      error: null,
    },
    delistPendingBankAccount: {
      status: null,
      error: null,
    },
  },
  reducers: {
    clearStatus: (state) => {
      for (const key in state) {
        // Clear status and error
        if (state[key]?.status) {
          state[key].status = null
        }
        if (state[key]?.error) {
          state[key].error = null
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // getFundBalance
      .addCase(getFundBalance.pending, (state, action) => {
        state.getFundBalance.status = 'loading'
      })
      .addCase(getFundBalance.fulfilled, (state, action) => {
        state.getFundBalance.status = 'succeeded'
        state.getFundBalance.error = null // Clear any previous errors

        // Store getFundBalance info
        if (action.payload.data.success) {
          state.fundBalance = action.payload.data.data.fundBalance
        }
      })
      .addCase(getFundBalance.rejected, (state, action) => {
        state.getFundBalance.status = 'failed'
        state.getFundBalance.error = {
          status: action.payload.status,
          message: action.payload.message, // Set the error message
        }

        // Clear pendingBankaccount info
      })
      // addBankAccount
      .addCase(addBankAccount.pending, (state, action) => {
        state.addBankAccount.status = 'loading'
      })
      .addCase(addBankAccount.fulfilled, (state, action) => {
        state.addBankAccount.status = 'succeeded'
        state.addBankAccount.error = null // Clear any previous errors

        // Store addBankAccount info
        if (action.payload.data.success) {
          state.pendingBankaccount = action.payload.data.data
        }
      })
      .addCase(addBankAccount.rejected, (state, action) => {
        state.addBankAccount.status = 'failed'
        state.addBankAccount.error = {
          status: action.payload.status,
          message: action.payload.message, // Set the error message
        }

        // Clear pendingBankaccount info
        state.pendingBankaccount = null
      })
      // updateBankAccount
      .addCase(updateBankAccount.pending, (state, action) => {
        state.updateBankAccount.status = 'loading'
      })
      .addCase(updateBankAccount.fulfilled, (state, action) => {
        state.updateBankAccount.status = 'succeeded'
        state.updateBankAccount.error = null // Clear any previous errors

        // Store updateBankAccount info
        if (action.payload.data.success) {
          state.pendingBankaccount = action.payload.data.data
        }
      })
      .addCase(updateBankAccount.rejected, (state, action) => {
        state.updateBankAccount.status = 'failed'
        state.updateBankAccount.error = {
          status: action.payload.status,
          message: action.payload.message, // Set the error message
        }

        // Clear pendingBankaccount info
        state.pendingBankaccount = null
      })
      // getBankAccount
      .addCase(getBankAccount.pending, (state, action) => {
        state.getBankAccount.status = 'loading'
      })
      .addCase(getBankAccount.fulfilled, (state, action) => {
        state.getBankAccount.status = 'succeeded'
        state.getBankAccount.error = null // Clear any previous errors

        // Store getBankAccount info
        if (action.payload.data.success) {
          state.bankAccount = action.payload.data.data
        }
      })
      .addCase(getBankAccount.rejected, (state, action) => {
        state.getBankAccount.status = 'failed'
        state.getBankAccount.error = {
          status: action.payload.status,
          message: action.payload.message, // Set the error message
        }

        // Clear bankAccount info
        state.bankAccount = null
      })
      // getPendingBankAccount
      .addCase(getPendingBankAccount.pending, (state, action) => {
        state.getPendingBankAccount.status = 'loading'
      })
      .addCase(getPendingBankAccount.fulfilled, (state, action) => {
        state.getPendingBankAccount.status = 'succeeded'
        state.getPendingBankAccount.error = null // Clear any previous errors

        // Store getPendingBankAccount info
        if (action.payload.data.success) {
          state.pendingBankaccount =
            Object.keys(action.payload.data.data).length !== 0 ? action.payload.data.data : null
        }
      })
      .addCase(getPendingBankAccount.rejected, (state, action) => {
        state.getPendingBankAccount.status = 'failed'
        state.getPendingBankAccount.error = {
          status: action.payload.status,
          message: action.payload.message, // Set the error message
        }

        // Clear bankAccount info
        state.pendingBankaccount = null
      })
      // delistBankAccount
      .addCase(delistBankAccount.pending, (state, action) => {
        state.delistBankAccount.status = 'loading'
      })
      .addCase(delistBankAccount.fulfilled, (state, action) => {
        state.delistBankAccount.status = 'succeeded'
        state.delistBankAccount.error = null // Clear any previous errors

        // Store delistBankAccount info
        if (action.payload.data.success) {
          state.bankAccount = null
        }
      })
      .addCase(delistBankAccount.rejected, (state, action) => {
        state.delistBankAccount.status = 'failed'
        state.delistBankAccount.error = {
          status: action.payload.status,
          message: action.payload.message, // Set the error message
        }
      })
      // withdrawFund
      .addCase(withdrawFund.pending, (state, action) => {
        state.withdrawFund.status = 'loading'
      })
      .addCase(withdrawFund.fulfilled, (state, action) => {
        state.withdrawFund.status = 'succeeded'
        state.withdrawFund.error = null // Clear any previous errors

        // Store withdrawFund info
      })
      .addCase(withdrawFund.rejected, (state, action) => {
        state.withdrawFund.status = 'failed'
        state.withdrawFund.error = {
          status: action.payload.status,
          message: action.payload.message, // Set the error message
        }

        // Clear withdrawFund info
      })
      // delistPendingBankAccount
      .addCase(delistPendingBankAccount.pending, (state, action) => {
        state.delistPendingBankAccount.status = 'loading'
      })
      .addCase(delistPendingBankAccount.fulfilled, (state, action) => {
        state.delistPendingBankAccount.status = 'succeeded'
        state.delistPendingBankAccount.error = null

        // Clear pendingBankaccount on success
        if (action.payload.data.success) {
          state.pendingBankaccount = null
        }
      })
      .addCase(delistPendingBankAccount.rejected, (state, action) => {
        state.delistPendingBankAccount.status = 'failed'
        state.delistPendingBankAccount.error = {
          status: action.payload.status,
          message: action.payload.message,
        }
      })
  },
})
export const { clearStatus } = bankAccountSlice.actions

export const getFundBalance = createAsyncThunk(
  'bankAccount/getFundBalance',
  async (payload, { rejectWithValue, getState }) => {
    try {
      // Access the global state
      //const state = getState()
      const response = await client.get(`/wallet`)

      return response
    } catch (error) {
      // Handle the error gracefully and return it as part of the payload
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      // API response error
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

export const addBankAccount = createAsyncThunk(
  'bankAccount/addBankAccount',
  async (payload, { rejectWithValue, getState }) => {
    try {
      // Access the global state
      //const state = getState()
      if (payload?.bookCoverPhoto?.length > 0 && payload?.accountNumber) {
        if (Array.isArray(payload?.bookCoverPhoto) && payload?.bookCoverPhoto.length > 0) {
          payload.bookCoverPhoto = payload?.bookCoverPhoto[0]
        }
      }
      const response = await client.post(`/finance/bank-account`, payload)

      return response
    } catch (error) {
      // Handle the error gracefully and return it as part of the payload
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      // API response error
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

export const updateBankAccount = createAsyncThunk(
  'bankAccount/updateBankAccount',
  async (payload, { rejectWithValue, getState }) => {
    try {
      // Access the global state
      //const state = getState()
      if (payload?.bookCoverPhoto?.length > 0 && payload?.accountNumber) {
        payload.bookCoverPhoto = payload?.bookCoverPhoto[0]
      }
      const response = await client.post(`/finance/bank-account`, payload)

      return response
    } catch (error) {
      // Handle the error gracefully and return it as part of the payload
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      // API response error
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

export const getBankAccount = createAsyncThunk(
  'bankAccount/getBankAccount',
  async (_, { rejectWithValue, getState }) => {
    try {
      // Access the global state
      // const state = getState()

      const response = await client.get(`/finance/bank-account`)

      return response
    } catch (error) {
      // Handle the error gracefully and return it as part of the payload
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      // API response error
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

export const getPendingBankAccount = createAsyncThunk(
  'bankAccount/getPendingBankAccount',
  async (params, { rejectWithValue, getState }) => {
    try {
      // Access the global state
      //const state = getState()
      const response = await client.get(`/finance/bank-account?pendingApproval=true`)

      return response
    } catch (error) {
      // Handle the error gracefully and return it as part of the payload
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      // API response error
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

export const delistBankAccount = createAsyncThunk(
  'bankAccount/delistBankAccount',
  async (params, { rejectWithValue, getState }) => {
    try {
      // Access the global state
      //const state = getState()
      const response = await client.post(`/finance/bank-account/delist`)

      return response
    } catch (error) {
      // Handle the error gracefully and return it as part of the payload
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      // API response error
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

export const withdrawFund = createAsyncThunk(
  'bankAccount/withdraw',
  async (params, { rejectWithValue, getState }) => {
    try {
      // Access the global state
      //const state = getState()
      const response = await client.post(`/finance/withdraw`, params)

      return response
    } catch (error) {
      // Handle the error gracefully and return it as part of the payload
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      // API response error
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

export const delistPendingBankAccount = createAsyncThunk(
  'bankAccount/delistPendingBankAccount',
  async (params, { rejectWithValue, getState }) => {
    try {
      const response = await client.post(`/finance/bank-account/delist-pending`)
      return response
    } catch (error) {
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
        return rejectWithValue({
          status: 503,
          message: error.message,
        })
      }
      return rejectWithValue({
        status: error.response?.status || 500,
        message: error.response?.data?.message || error.message,
      })
    }
  },
)

// Selector (Read data) - used with useSelector

export const selectFundBalance = (state) => state.bankAccount.fundBalance
export const selectGetFundBalanceStatus = (state) => state.bankAccount.getFundBalance.status
export const selectGetFundBalanceError = (state) => state.bankAccount.getFundBalance.error

export const selectAddBankAccountStatus = (state) => state.bankAccount.addBankAccount.status
export const selectAddBankAccountError = (state) => state.bankAccount.addBankAccount.error

export const selectUpdateBankAccountStatus = (state) => state.bankAccount.updateBankAccount.status
export const selectUpdateBankAccountError = (state) => state.bankAccount.updateBankAccount.error

export const selectBankAccount = (state) => state.bankAccount.bankAccount
export const selectGetBankAccountStatus = (state) => state.bankAccount.getBankAccount.status
export const selectGetBankAccountError = (state) => state.bankAccount.getBankAccount.error

export const selectPendingBankAccount = (state) => state.bankAccount.pendingBankaccount
export const selectGetPendingBankAccountStatus = (state) =>
  state.bankAccount.getPendingBankAccount.status
export const selectGetPendingBankAccountError = (state) =>
  state.bankAccount.getPendingBankAccount.error

export const selectDelistBankAccountStatus = (state) => state.bankAccount.delistBankAccount.status
export const selectDelistBankAccountError = (state) => state.bankAccount.delistBankAccount.error

export const selectWithdrawFundStatus = (state) => state.bankAccount.withdrawFund.status
export const selectWithdrawFundError = (state) => state.bankAccount.withdrawFund.error

export const selectDelistPendingBankAccountStatus = (state) =>
  state.bankAccount.delistPendingBankAccount.status
export const selectDelistPendingBankAccountError = (state) =>
  state.bankAccount.delistPendingBankAccount.error

export default bankAccountSlice.reducer
